/* AUTO-GENERATED from content/ir by scripts/build-ir-content.ts. Do not edit. */
import type { IRPost } from '../types/ir'
export const irPosts: IRPost[] = [
  {
    "slug": "2026-10-06-share-issuance",
    "date": "2026-10-06",
    "category": "notice",
    "title": {
      "en": "Notice of New Share Issuance (Third-Party Allotment)",
      "ko": "신주발행(제3자배정 유상증자) 공고"
    },
    "seoTitle": {
      "en": "Notice of New Share Issuance",
      "ko": "신주발행 공고: 제3자배정 유상증자"
    },
    "description": {
      "en": "Notice of the third-party allotment resolved on October 6, 2026: share class and quantity, issue price, total issue amount, and payment date.",
      "ko": "2026년 10월 6일 이사회에서 결의한 제3자배정 유상증자에 관한 공고입니다. 신주의 종류·수, 발행가액, 발행총액 및 납입기일을 안내합니다."
    },
    "centeredParagraphs": {
      "en": [
        "October 6, 2026",
        "GIGAette Co., Ltd.",
        "Representative Director Daejun Chang"
      ],
      "ko": [
        "– 아 래 –",
        "2026년 10월 06일",
        "주식회사 기가에떼",
        "대표이사 장대준"
      ]
    },
    "attachment": "/downloads/ir/2026-10-06-share-issuance-notice.pdf",
    "seal": {
      "image": "/images/ir/gigaette-korean-stamp.webp",
      "company": {
        "en": "GIGAette Co., Ltd.",
        "ko": "주식회사 기가에떼"
      }
    },
    "popup": {
      "from": "2026-10-06T00:00:00+09:00",
      "until": "2026-10-24T00:00:00+09:00",
      "version": 1
    }
  }
]
